import {
  FileText,
  AlertCircle,
  ClipboardList,
  Trophy,
  FlaskConical,
  Target,
} from "lucide-react";
import type { EvaluationType_Option } from "./types";

export const EVALUATION_TYPES: EvaluationType_Option[] = [
  { id: "monthly_exam", label: "Prova Mensal", icon: FileText },
  { id: "bimonthly_exam", label: "Prova Bimestral", icon: AlertCircle },
  { id: "mock_exam", label: "Simulado", icon: ClipboardList },
  { id: "final_project", label: "Trabalho Final", icon: Trophy },
  {
    id: "practical_activity",
    label: "Atividade Prática",
    icon: FlaskConical,
  },
  { id: "quiz", label: "Quiz/Teste", icon: Target },
];

export const INITIAL_FORM_DATA = {
  title: "",
  subject: "",
  class: "",
  type: "monthly_exam" as const,
  weight: "10.0",
  dueDate: "",
  professorName: "",
  schoolName: "",
  objetivas: 0,
  dissertativas: 0,
};

export const N8N_WEBHOOK_URL =
  "https://brennovic08.app.n8n.cloud/webhook/CriadorDeAvaliaçao";

export const MODAL_ANIMATION_CLASS = "animate-in fade-in zoom-in duration-200";
